import React from 'react';
import { Hero } from '../components/Hero';
import { TopSellers } from '../components/TopSellers';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1783">
      <Hero data-id="element-1784" />
      <TopSellers data-id="element-1785" />
      <WhyUs data-id="element-1786" />
      <Services data-id="element-1787" />
      <HowItWorks data-id="element-1788" />
      <FAQ data-id="element-1789" />
      <Reviews data-id="element-1790" />
      <CtaBanner data-id="element-1791" />
    </main>;
}